<template>
  <div class="swa-filter-sort-bar">
    <div class="filter-sort-container">
      <div class="filter-sort-section headline-m">
        <slot name="filter-btn"></slot>
      </div>
      <button class="filter-sort-section headline-m">
        <slot name="sort-btn"></slot>
      </button>
    </div>
  </div>
</template>

<script lang="ts" setup>
const observer = new MutationObserver(() => {
  const filterSortBar = document.querySelector(
    '.swa-filter-sort-bar'
  ) as HTMLElement

  const searchBar = document.querySelector('#layout-header-container')

  if (filterSortBar && searchBar) {
    const topOffset = searchBar.clientHeight

    filterSortBar.style.top = `${topOffset}px`
  }
})

onMounted(() => {
  observer.observe(document.body, { childList: true, subtree: true })
})

onBeforeUnmount(() => {
  observer.disconnect()
})
</script>

<style lang="scss" scoped>
.swa-filter-sort-bar {
  position: sticky;
  top: 0;
  z-index: 2;
  --sort-filter-btn-height: 48px;
  height: var(--sort-filter-btn-height);

  .filter-sort-container {
    width: 100%;
    display: grid;
    grid: 1fr / 1fr 1fr;
    gap: 1px;
    background-color: var(--color-border-divider-secondary);

    .filter-sort-section {
      border: 1px solid var(--color-border-divider-secondary);
      border-left: none;
      border-right: none;

      background-color: var(--color-base-white);
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px;

      span {
        font-weight: var(--size-typography-weight-bold);
      }

      :deep(.modal-trigger-btn) {
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }
}

button {
  all: unset;
  line-height: 0;
  cursor: pointer;
}
</style>
